import FoxMark from "./FoxMark";

export const Hero = ({ onBook }) => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative pt-40 pb-28 lg:pt-48 lg:pb-40 overflow-hidden"
    >
      {/* Ornamental fox watermark — your geometric fox, transparent bg over the ivory page */}
      <div
        aria-hidden
        className="absolute right-0 top-32 pointer-events-none hidden md:block"
      >
        <img
          src="/logos/sfa-fox-mark.png"
          alt=""
          className="w-[560px] h-[560px] object-contain opacity-90"
        />
      </div>

      <div className="max-w-7xl mx-auto px-6 sm:px-10 grid lg:grid-cols-12 gap-12 items-end relative">
        <div className="lg:col-span-7 reveal">
          <div className="flex items-center gap-4 mb-10">
            <span className="h-px w-16 bg-[#161618]" />
            <span className="text-[0.65rem] uppercase tracking-[0.38em] text-[#4D4A47]">
              Laser &amp; Advanced Aesthetics · UK
            </span>
          </div>

          <h1
            data-testid="hero-headline"
            className="font-serif font-light leading-[0.95] tracking-tight text-[#161618] text-6xl sm:text-7xl lg:text-[7.5rem]"
          >
            Quiet
            <br />
            <span className="italic text-[#B6AA96]">luxury</span> for
            <br />
            the modern
            <br />
            face.
          </h1>

          <p
            data-testid="hero-subtitle"
            className="mt-10 max-w-xl text-lg sm:text-xl text-[#4D4A47] font-light leading-relaxed"
          >
            Advanced injectables, skin boosters and regenerative treatments —
            delivered by Stacy Fox, a registered aesthetic practitioner with a
            signature for subtle, elegant results.
          </p>

          <div className="mt-12 flex flex-wrap gap-4">
            <button
              onClick={onBook}
              data-testid="hero-book-btn"
              className="btn-primary"
            >
              Book Consultation
            </button>
            <a href="#treatments" data-testid="hero-treatments-btn" className="btn-ghost">
              Explore Treatments
            </a>
          </div>

          <div className="mt-16 grid grid-cols-3 gap-8 max-w-md">
            <Stat value="5+" label="Years experience" />
            <Stat value="2.4k" label="Clients treated" />
            <Stat value="5.0" label="Google rating" />
          </div>
        </div>

        <div className="lg:col-span-5 reveal">
          <div className="relative flex items-center justify-center">
            <div className="absolute inset-0 -m-8 border border-[#C9BEA9] hidden lg:block" aria-hidden />
            <img
              src="/logos/sfa-primary.png"
              alt="Stacy Fox — Laser & Advanced Aesthetics"
              className="relative w-full max-w-[480px] h-auto"
              data-testid="hero-brand-mark"
            />
            <div className="absolute -bottom-6 -left-2 bg-[#F1EDDE] border border-[#161618] py-3 px-5 hidden sm:flex items-center gap-3">
              <FoxMark className="w-7 h-5" stroke="#161618" />
              <span className="font-serif italic text-[#161618]">stacyfoxaesthetics</span>
            </div>
          </div>
        </div>
      </div>

      {/* Marquee */}
      <div className="mt-28 border-y border-[#C9BEA9] overflow-hidden py-5">
        <div className="marquee-track flex items-center gap-16 whitespace-nowrap text-[#4D4A47] font-serif italic text-2xl">
          {Array.from({ length: 2 }).map((_, i) => (
            <div key={i} className="flex items-center gap-16 pr-16">
              <span>Botox</span><Dot />
              <span>Lip Filler</span><Dot />
              <span>Profhilo</span><Dot />
              <span>Skin Boosters</span><Dot />
              <span>Dermal Filler</span><Dot />
              <span>Microneedling</span><Dot />
              <span>Polynucleotides</span><Dot />
              <span>Anti-Wrinkle</span><Dot />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const Dot = () => <span className="w-1.5 h-1.5 rounded-full bg-[#B6AA96]" />;
const Stat = ({ value, label }) => (
  <div>
    <div className="font-serif text-4xl text-[#161618]">{value}</div>
    <div className="text-[0.65rem] uppercase tracking-[0.22em] text-[#8C8580] mt-2">
      {label}
    </div>
  </div>
);

export default Hero;
